import React, { Component } from 'react';
import {
  Snackbar,
} from '@material-ui/core';
import TimeToListReportGeneration from '../components/E2E/TimeToListReportGeneration';

class ReportingView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      snackOpen: false,
      snackbarMessage: null,
    }
  }

  displaySnackbar = (message) => {
    this.setState({
      snackOpen: true,
      snackbarMessage: message,
    });
  };

  hideSnackbar = () => {
    this.setState({ snackOpen: false });
  };

  render() {
    const {
      snackOpen,
      snackbarMessage,
    } = this.state;
    
    return (
      <>
        <TimeToListReportGeneration displaySnackbar={this.displaySnackbar} />
        <Snackbar
          message={snackbarMessage}
          open={snackOpen}
          onClose={this.hideSnackbar}
          autoHideDuration={2000}
        />
      </>
    )
  }
}

export default ReportingView;
